<template>
  <div>
    <v-container class="pa-0 mt-4" v-if="!silent_update">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="$t('attendees.accomplishment_for', { course_name: course.name })"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="back" @click="$router.go(-1)" />
        <action-button type="save" @click="preSave" />
      </v-app-bar>

      <v-form ref="form">
        <v-container grid-list-md>
          <v-card>
            <v-card-text class="pa-4">
              <v-layout row wrap>
                <v-flex xs12>
                  <div class="table-sticky-wrapper">
                    <v-simple-table dense class="v-data-table--fixed-header" :height="`auto`" :style="cssVars">
                      <template v-slot:default>
                        <thead>
                          <!-- HEADER -->
                          <tr>
                            <th :class="`text-left col-sticky`">{{ $t("attendees.participant_id") }}</th>
                            <template v-for="moduletemplate in moduletemplates">
                              <th
                                :class="`text-center ` + (moduleoption.mandatory_accomplishment ? 'required-field' : '')"
                                v-for="moduleoption in moduletemplate.moduleoptions"
                                :key="'header-mo-' + moduleoption.id"
                              >
                                {{ moduleoption.name }}
                              </th>
                              <th class="text-center primary white--text" :key="'header-mt' + moduletemplate.id">
                                <span :class="moduletemplate.mandatory ? 'required-field' : ''">{{ moduletemplate.name }}</span>
                              </th>
                            </template>
                            <th :class="`text-center primary white--text ${stickyColumnClass}`">{{ $t("attendees.course_completed") }}</th>
                            <th v-if="coursetemplate && coursetemplate.type == 1" :class="`text-center primary white--text ${stickyColumnClass}`">
                              {{ $t("attendees.release_certificate") }}
                            </th>
                            <th :class="`text-center ${stickyColumnClass}`">{{ $t("attendees.total_percentage_of_student") }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <!-- SELECT ALL -->
                          <tr>
                            <td :class="`text-left col-sticky`">&nbsp;</td>
                            <template v-for="moduletemplate in moduletemplates">
                              <td
                                class="text-center"
                                v-for="moduleoption in moduletemplate.moduleoptions"
                                :key="'selectall-mo-' + moduleoption.id"
                              >
                                <v-checkbox
                                  dense
                                  hide-details
                                  class="align-center justify-center d-grid acc-chkbox"
                                  @change="selectAllColumn('mo', moduleoption.id, $event)"
                                />
                              </td>
                              <td class="text-center primary white--text" :key="'selectall-mt-' + moduletemplate.id">
                                <v-checkbox
                                  dense
                                  hide-details
                                  dark
                                  class="align-center justify-center d-grid acc-chkbox"
                                  @change="selectAllColumn('mt', moduletemplate.id, $event)"
                                />
                              </td>
                            </template>
                            <td :class="`text-center primary white---text ${stickyColumnClass}`">
                              <v-checkbox
                                v-model="selectAllCourseCompleted"
                                dense
                                hide-details
                                dark
                                class="align-center justify-center d-grid acc-chkbox"
                                @change="selectAllRow(null, selectAllCourseCompleted)"
                              />
                            </td>
                            <td v-if="coursetemplate && coursetemplate.type == 1" :class="`text-center primary white---text ${stickyColumnClass}`"></td>
                            <td :class="`text-center ${stickyColumnClass}`">&nbsp;</td>
                          </tr>

                          <!-- PARTICIPANTS -->
                          <tr v-for="attendee in attendees" :key="attendee.id">
                            <td :class="`text-left col-sticky pl-2 pr-5`">
                              <a class="float-left" @click="showForm(attendee.participant_id, 'participant')">
                                {{ attendee.participant.full_name }}
                              </a>

                              <!-- HISTORY BUTTON -->
                              <v-btn icon x-small text class="absolute-center" color="primary" @click="openHistoryDialog(attendee)">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on">history</v-icon>
                                  </template>
                                  <span>{{ $t("global.view_history") }}</span>
                                </v-tooltip>
                              </v-btn>
                            </td>
                            <template v-for="moduletemplate in moduletemplates">
                              <td
                                class="text-center"
                                v-for="moduleoption in moduletemplate.moduleoptions"
                                :key="'student-mo-' + moduleoption.id"
                              >
                                <v-checkbox
                                  dense
                                  hide-details
                                  v-model="data['student-' + attendee.id].mt['mt-' + moduletemplate.id].mo['mo-' + moduleoption.id].value"
                                  class="align-center justify-center d-grid acc-chkbox"
                                  @change="postData()"
                                  :disabled="disabled_moduleoptions['student-' + attendee.id]['mo-' + moduleoption.id]"
                                />
                              </td>
                              <td class="text-center primary white--text" :key="'student-mt-' + moduletemplate.id">
                                <v-checkbox
                                  dense
                                  hide-details
                                  dark
                                  v-model="data['student-' + attendee.id].mt['mt-' + moduletemplate.id].value"
                                  class="align-center justify-center d-grid acc-chkbox"
                                  @change="postData()"
                                  :disabled="disabled_moduletemplates['student-' + attendee.id]['mt-' + moduletemplate.id]"
                                />
                              </td>
                            </template>
                            <td :class="`text-center primary white--text ${stickyColumnClass}`">
                              <div class="d-flex align-center justify-center">
                                <v-checkbox
                                  dense
                                  hide-details
                                  dark
                                  :input-value="total_coursecompleted['student-' + attendee.id]"
                                  class="align-center justify-center d-grid acc-chkbox"
                                  @click.stop="clickCourseCompleted(attendee.id)"
                                />
                                <v-btn
                                  v-if="total_coursecompleted['student-' + attendee.id]"
                                  icon
                                  x-small
                                  dark
                                  @click.stop="openDateDialog(attendee.id)"
                                >
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon v-bind="attrs" v-on="on" small>event</v-icon>
                                    </template>
                                    <span>{{ $t("attendees.set_completion_date") }}</span>
                                  </v-tooltip>
                                </v-btn>
                                <span
                                  v-if="total_coursecompleted['student-' + attendee.id] && data['student-' + attendee.id].date_completed_override"
                                  class="ml-1 caption"
                                >
                                  {{ $dateFormatGetter(data["student-" + attendee.id].date_completed_override) }}
                                </span>
                              </div>
                            </td>
                            <td v-if="coursetemplate && coursetemplate.type == 1" :class="`text-center primary white---text ${stickyColumnClass}`">
                              <v-checkbox
                                dense
                                hide-details
                                dark
                                :input-value="release_certificate['student-' + attendee.id]"
                                class="align-center justify-center d-grid acc-chkbox"
                                @click.stop="clickReleaseCertificate(attendee.id)"
                              />
                            </td>
                            <td :class="`text-center ${stickyColumnClass}`" :key="attendee.id">
                              {{ data["student-" + attendee.id].total }}
                            </td>
                          </tr>

                          <!-- TOTAL -->
                          <tr>
                            <td :class="`text-left col-sticky`">{{ $t("attendees.total_percentage") }}</td>
                            <template v-for="moduletemplate in moduletemplates">
                              <td
                                class="text-center"
                                v-for="moduleoption in moduletemplate.moduleoptions"
                                :key="'total-mo-' + moduleoption.id"
                              >
                                {{ total_moduleoptions["mo-" + moduleoption.id] }}
                              </td>
                              <td class="text-center primary white--text" :key="'total-mt-' + moduletemplate.id">
                                {{ total_moduletemplates["mt-" + moduletemplate.id] }}
                              </td>
                            </template>
                            <td :class="`text-center primary white--text ${stickyColumnClass}`">
                              {{ total_sum_coursecompleted }}
                            </td>
                            <td v-if="coursetemplate && coursetemplate.type == 1" :class="`text-center primary white---text ${stickyColumnClass}`">&nbsp;</td>
                            <td :class="`text-center ${stickyColumnClass}`">
                              {{ total }}
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-container>
      </v-form>
    </v-container>

    <v-dialog v-model="showDialogForm" persistent max-width="90%">
      <div class="form-modal pa-4">
        <component
          :is="currentLoadedForm.form"
          :id="currentLoadedForm.id"
          :modal="true"
          :from_module="currentFromModule"
          @return_modal_form="return_modal_form"
          @return_modal_cancel_form="return_modal_cancel_form"
        ></component>
      </div>
    </v-dialog>

    <v-dialog v-model="showHistoryDialog" persistent max-width="50%">
      <div class="form-modal pa-3">
        <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
          <page-header-title :title="computedHistoryTitle"></page-header-title>
          <v-spacer></v-spacer>
          <action-button small type="cancel" @click="closeHistoryDialog()" />
        </v-app-bar>

        <v-simple-table class="tbl-titles ma-0" dense>
          <tbody>
            <tr v-for="(item, index) in logs" :key="index">
              <td width="20%">{{ item.date }}</td>
              <td>{{ item.log }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
    </v-dialog>

    <v-dialog v-model="showDateDialog" persistent width="290px">
      <v-date-picker color="primary" v-model="computedSelectedDate" first-day-of-week="1" :locale="this.$locale_bcp47()">
        <v-btn text color="primary" @click="clearSelectedDate()">{{ $t("global.clear") }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="closeDateDialog()" class="darken-2">{{ $t("global.ok") }}</v-btn>
      </v-date-picker>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "Accomplishment",

  props: ["id", "silent_update"],

  components: {
    "participant-form": () => import("../../participants/components/Form")
  },

  data() {
    return {
      course: {},
      coursetemplate: {},
      moduletemplates: [],
      attendees: [],

      before_total_coursecompleted: [],
      before_release_certificate: [],
      before_data: [],

      data: {},
      total_moduletemplates: {},
      total_moduleoptions: {},
      total_coursecompleted: {},
      release_certificate: {},

      disabled_moduletemplates: {},
      disabled_moduleoptions: {},

      total: 0,
      total_columns: 0,
      total_sum_coursecompleted: 0,

      windowHeight: window.innerHeight - 200,
      windowWidth: window.innerWidth - 60,

      selectAllCourseCompleted: false,

      currentFormId: null,
      currentForm: null,
      currentFromModule: "accomplishment",
      showDialogForm: false,

      showHistoryDialog: false,
      selectedAttendee: {},
      logs: [],

      showDateDialog: false,
      selectedDateAttendeeId: null,
      total: 0,
      show_loading: false,
      refresh: false,
      pagination: {
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["created_at"],
        sortDesc: [true]
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    let valid = true

    if (!_.isEqual(this.before_total_coursecompleted, this.total_coursecompleted)) {
      valid = false
    }
    if (!_.isEqual(this.before_release_certificate, this.release_certificate)) {
      valid = false
    }
    if (!_.isEqual(this.before_data, this.data)) {
      valid = false
    }

    if (!valid) {
      this.$awn.confirm(
        this.$t("global.discard_changes"),
        () => {
          next()
        },
        () => {
          next(false)
        },
        {
          labels: {
            confirmOk: this.$t("global.yes"),
            confirmCancel: this.$t("global.no")
          }
        }
      )
    } else {
      next()
    }
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.windowHeight = window.innerHeight - 200
        this.windowWidth = window.innerWidth - 60
      })
    })
  },

  created() {
    if (this.id) {
      axios
        .get(this.API_URL + "course/" + this.id + "?resourcetype=course-accomplishment")
        .then((res) => {
          this.course = res.data.data
          this.coursetemplate = this.course.coursetemplate
          this.moduletemplates = res.data.data.moduletemplates.filter((i) => !i.hide_in_accomplishment)

          this.attendeeList()
        })
        .catch((err) => console.log(err))
    }
  },

  computed: {
    stickyColumnClass() {
      return this.$vuetify.breakpoint.mdAndDown ? "" : "sticky"
    },
    cssVars() {
      let drawer = this.$store.getters["master/drawerOpen"]

      if(drawer) {
          this.windowWidth = this.windowWidth - 270;
      }

      return {
        "--width": this.windowWidth + "px",
      }
    },
    currentLoadedForm: function () {
      let form,
        id = null

      if (this.currentForm) {
        this.showDialogForm = true

        id = this.currentFormId
        form = this.currentForm
      }

      return {
        id: id,
        form: form
      }
    },
    computedHistoryTitle() {
      if (this.selectedAttendee) {
        return this.selectedAttendee.full_name || ""
      }
    },
    computedSelectedDate: {
      get() {
        if (!this.selectedDateAttendeeId) return null
        return this.data["student-" + this.selectedDateAttendeeId].date_completed_override
      },
      set(val) {
        if (!this.selectedDateAttendeeId) return
        this.$set(this.data["student-" + this.selectedDateAttendeeId], "date_completed_override", val)
      }
    }
  },

  methods: {
    attendeeList() {
      axios.get(this.API_URL + "attendees?resourcetype=attendee-accomplishment&show_all=true&query_course_id=" + this.id).then((res) => {
        let attendee = JSON.parse(JSON.stringify(res.data.data))

        this.attendees = attendee
        this.attendees_beforesave = attendee
        this.preData()
      })
    },
    preData() {
      this.total = 0
      this.total_columns = 0
      this.total_sum_coursecompleted = 0

      this.attendees.forEach((attendee, index) => {
        this.$set(this.data, "student-" + attendee.id, { mt: {}, total: 0, date_completed: null, date_completed_override: null })

        this.total_coursecompleted["student-" + attendee.id] = false
        this.release_certificate["student-" + attendee.id] = false

        this.disabled_moduletemplates["student-" + attendee.id] = {}
        this.disabled_moduleoptions["student-" + attendee.id] = {}

        this.moduletemplates.forEach((moduletemplate, index) => {
          this.data["student-" + attendee.id].mt["mt-" + moduletemplate.id] = { value: null, mo: {} }

          this.disabled_moduletemplates["student-" + attendee.id]["mt-" + moduletemplate.id] = true

          this.total_moduletemplates["mt-" + moduletemplate.id] = 0
          this.total_columns++

          moduletemplate.moduleoptions.forEach((moduleoption, index) => {
            this.data["student-" + attendee.id].mt["mt-" + moduletemplate.id].mo["mo-" + moduleoption.id] = { value: null }

            this.disabled_moduleoptions["student-" + attendee.id]["mo-" + moduleoption.id] = true

            this.total_moduleoptions["mo-" + moduleoption.id] = 0
            //this.total_columns++;
          })
        })

        if (attendee.accomplishment_data) {
          this.$set(this.data, "student-" + attendee.id, JSON.parse(attendee.accomplishment_data))

          // Backfill fields that may not exist in older stored accomplishment data
          if (this.data["student-" + attendee.id].date_completed === undefined) {
            this.$set(this.data["student-" + attendee.id], "date_completed", null)
          }
          if (this.data["student-" + attendee.id].date_completed_override === undefined) {
            this.$set(this.data["student-" + attendee.id], "date_completed_override", null)
          }

          // Check if total is already 100
          if (this.data["student-" + attendee.id].total == 100) {
            this.total_coursecompleted["student-" + attendee.id] = true
          }

          if (this.coursetemplate && this.coursetemplate.type == 2) {
            // 2 = Long Course
            this.release_certificate["student-" + attendee.id] = true
          } else {
            this.release_certificate["student-" + attendee.id] = Boolean(attendee.release_certificate)
          }
        }
      })

      this.ensureModuleTemplateKeys()

      this.total_columns = this.total_columns / this.attendees.length

      this.reValidation()
      this.postData()

      // Update old values/arrays
      this.before_total_coursecompleted = JSON.parse(JSON.stringify(this.total_coursecompleted))
      this.before_release_certificate = JSON.parse(JSON.stringify(this.release_certificate))
      this.before_data = JSON.parse(JSON.stringify(this.data))
    },
    // Backfills any mt/mo keys missing from an attendee's stored accomplishment data
    // (e.g. a module template added to the course after the data was last saved),
    // so later reads of data[...].mt[...] never hit an undefined entry.
    ensureModuleTemplateKeys() {
      this.attendees.forEach((attendee) => {
        let studentData = this.data["student-" + attendee.id]
        if (!studentData) return
        if (!studentData.mt) {
          this.$set(studentData, "mt", {})
        }

        this.moduletemplates.forEach((moduletemplate) => {
          if (studentData.mt["mt-" + moduletemplate.id] === undefined) {
            this.$set(studentData.mt, "mt-" + moduletemplate.id, { value: null, mo: {} })
          }

          moduletemplate.moduleoptions.forEach((moduleoption) => {
            if (studentData.mt["mt-" + moduletemplate.id].mo["mo-" + moduleoption.id] === undefined) {
              this.$set(studentData.mt["mt-" + moduletemplate.id].mo, "mo-" + moduleoption.id, { value: null })
            }
          })
        })
      })
    },
    postData() {
      this.ensureModuleTemplateKeys()

      let _total_moduletemplates = JSON.parse(JSON.stringify(this.total_moduletemplates))
      let _total_moduleoptions = JSON.parse(JSON.stringify(this.total_moduleoptions))
      let _total_coursecompleted = JSON.parse(JSON.stringify(this.total_coursecompleted))
      let _release_certificate = JSON.parse(JSON.stringify(this.release_certificate))
      let _previousCourseCompleted = JSON.parse(JSON.stringify(this.total_coursecompleted))

      let _checked_mt = {}
      let _checked_mo = {}
      let _sum_total_participant = 0
      let _sum_total_completed = 0

      // Re-validation
      this.reValidation()

      // Check if mandatory moduletemplate is checked and update _total_coursecompleted variable
      this.attendees.forEach((attendee, index) => {
        this.disableCourseCompleted(attendee.id)
      })
      _total_coursecompleted = JSON.parse(JSON.stringify(this.total_coursecompleted))

      // Row Computation
      this.attendees.forEach((attendee, index) => {
        let _checked_row = 0

        this.moduletemplates.forEach((moduletemplate, index) => {
          // _checked_mt is used for column computation
          if (!("mt-" + moduletemplate.id in _checked_mt)) {
            _checked_mt["mt-" + moduletemplate.id] = 0
          }

          // Check if moduletemplate checkbox is checked
          if (this.data["student-" + attendee.id].mt["mt-" + moduletemplate.id].value) {
            _checked_row++
            _checked_mt["mt-" + moduletemplate.id]++
          }

          moduletemplate.moduleoptions.forEach((moduleoption, index) => {
            if (!("mo-" + moduleoption.id in _checked_mo)) {
              _checked_mo["mo-" + moduleoption.id] = 0
            }

            // Check if moduleoption checkbox is checked
            if (this.data["student-" + attendee.id].mt["mt-" + moduletemplate.id].mo["mo-" + moduleoption.id].value) {
              //_checked_row++;
              _checked_mo["mo-" + moduleoption.id]++
            }
          })
        })

        // Compute for the row total % for student
        // Formula: Total number of co
        let rowPercentage = Math.round((100 / this.total_columns) * _checked_row)

        // Check if the course completed checkbox is checked, if checked, set the rowPercentage to 100
        if (_total_coursecompleted["student-" + attendee.id]) {
          rowPercentage = 100
        }

        // Set to total computation
        this.data["student-" + attendee.id].total = rowPercentage

        // Set release certificate
        if (this.coursetemplate && this.coursetemplate.type == 2) {
          // 2 = Long Course
          this.data["student-" + attendee.id].release_certificate = true
        } else {
          this.data["student-" + attendee.id].release_certificate = Boolean(_release_certificate["student-" + attendee.id])
        }

        // Check if the student already completed the accomplishment
        /*if(this.data['student-' + attendee.id].total != 100)  {
                    // Override rowPercentage if course completed checkbox is checked manually
                    if(_total_coursecompleted['student-' + attendee.id]) {
                        rowPercentage = 100;
                    }

                    this.data['student-' + attendee.id].total = rowPercentage;
                } else {
                    // Set the row percentage to 100 since the student already completed the accomplishment
                    rowPercentage = 100;
                }     */

        // Total all the "Total % for Student in _sum_total_participant variable and will be used for computing the grand total"
        _sum_total_participant += this.data["student-" + attendee.id].total

        // Auto check course completed checkbox
        if (rowPercentage == 100) {
          _total_coursecompleted["student-" + attendee.id] = true
          _sum_total_completed++
        } else {
          // Course completed is going from checked to unchecked (either clicked directly,
          // or a module got unchecked) - the previously recorded completion date no longer applies
          if (_previousCourseCompleted["student-" + attendee.id]) {
            this.$set(this.data["student-" + attendee.id], "date_completed", null)
            this.$set(this.data["student-" + attendee.id], "date_completed_override", null)
          }

          _total_coursecompleted["student-" + attendee.id] = false
        }
      })

      // Column computation for Module Template
      // Formula: 100 / Number of Attendees * Number of checked module template in a column
      for (const [index, mt] of Object.entries(_checked_mt)) {
        _total_moduletemplates[index] = Math.round((100 / this.attendees.length) * _checked_mt[index])
      }

      // Column computation for Module Option
      // Formula: 100 / Number of Attendees * Number of checked module option in a column
      for (const [index, mo] of Object.entries(_checked_mo)) {
        _total_moduleoptions[index] = Math.round((100 / this.attendees.length) * _checked_mo[index])
      }

      // Re-render to view
      this.total_moduletemplates = _total_moduletemplates
      this.total_moduleoptions = _total_moduleoptions
      this.total_coursecompleted = _total_coursecompleted
      this.release_certificate = _release_certificate

      if (this.attendees.length > 0) {
        // Course Completed formula: Checked course completed checkbox / number of attendees * 100
        this.total_sum_coursecompleted = Math.round((_sum_total_completed / this.attendees.length) * 100)

        // Total formula: sum of "Total % for students" / number of attendees
        this.total = Math.round(_sum_total_participant / this.attendees.length)
      }

      if (this.silent_update) {
        this.save(true)
      }
    },
    reValidation() {
      let _disabled_moduleoptions = JSON.parse(JSON.stringify(this.disabled_moduleoptions))
      let _disabled_moduletemplates = JSON.parse(JSON.stringify(this.disabled_moduletemplates))

      this.attendees.forEach((attendee, index) => {
        let prevChkMand = false // variable that holds if the previous checkbox is required
        let prevValue = false // variable that holds the previous value if checked or not

        this.moduletemplates.forEach((moduletemplate, index) => {
          // Enable/Disable module option checkbox
          moduletemplate.moduleoptions.forEach((moduleoption, index) => {
            if (prevChkMand == false) {
              // If the previous checkbox is not required, enable module option checkbox
              _disabled_moduleoptions["student-" + attendee.id]["mo-" + moduleoption.id] = false
            } else {
              if (prevValue) {
                // If previous checkbox is checked, reset preChkMand and search again for the next required checkbox
                prevChkMand = false
                _disabled_moduleoptions["student-" + attendee.id]["mo-" + moduleoption.id] = false
              } else {
                // If the previous checkbox is not required, disable module option checkbox
                _disabled_moduleoptions["student-" + attendee.id]["mo-" + moduleoption.id] = true
                this.data["student-" + attendee.id].mt["mt-" + moduletemplate.id].mo["mo-" + moduleoption.id].value = false
              }
            }

            if (moduleoption.mandatory_accomplishment) {
              prevChkMand = true

              if (this.data["student-" + attendee.id].mt["mt-" + moduletemplate.id].mo["mo-" + moduleoption.id].value) {
                prevValue = true
              } else {
                prevValue = false
              }
            }
          })

          // Enable/Disable module template checkbox
          if (prevChkMand == false) {
            // If the previous checkbox is not required, enable module template
            _disabled_moduletemplates["student-" + attendee.id]["mt-" + moduletemplate.id] = false
          } else {
            if (prevValue) {
              // If previous checkbox is checked, reset preChkMand and search again for the next required checkbox
              prevChkMand = false
              _disabled_moduletemplates["student-" + attendee.id]["mt-" + moduletemplate.id] = false
            } else {
              // If the previous checkbox is not required, disable module template checkbox
              _disabled_moduletemplates["student-" + attendee.id]["mt-" + moduletemplate.id] = true
              this.data["student-" + attendee.id].mt["mt-" + moduletemplate.id].value = false
            }
          }
        })
      })

      this.disabled_moduleoptions = _disabled_moduleoptions
      this.disabled_moduletemplates = _disabled_moduletemplates
    },
    clickCourseCompleted(id) {
      let obj = this.disableCourseCompleted(id)
      if (obj.value) {
        if (obj.type == "mandatory") {
          this.$awn.alert(this.$t("attendees.mandatory_module_required"))
        }

        if (obj.type == "birthday") {
          this.$awn.alert(this.$t("attendees.birthday_required"))
        }
      } else {
        var checked = !Boolean(this.total_coursecompleted['student-' + id])
        this.$set(this.total_coursecompleted, 'student-' + id, checked)
        this.selectAllRow(id, checked)
      }
    },
    disableCourseCompleted(id) {
      this.ensureModuleTemplateKeys()

      var has_mandatory = false // Search "has_mandatory" for other code
      var has_birthday = this.attendeeHasBirthday(id)

      this.moduletemplates.forEach((moduletemplate, index) => {
        if (!this.data["student-" + id] || !this.data["student-" + id].mt["mt-" + moduletemplate.id]) {
          return
        }
        var chk = this.data["student-" + id].mt["mt-" + moduletemplate.id].value
        if (moduletemplate.mandatory && !chk) {
          has_mandatory = true
        }
      })

      if (has_mandatory || !has_birthday) {
        this.$set(this.total_coursecompleted, "student-" + id, false)
      }

      return {
        value: Boolean(has_mandatory || !has_birthday),
        type: has_mandatory ? "mandatory" : !has_birthday ? "birthday" : null
      }
    },
    clickReleaseCertificate(id) {
      let obj = this.disableReleaseCertificate(id)
      if (obj.value) {
        if (obj.type == "birthday") {
          this.$awn.alert(this.$t("attendees.birthday_required"))
        }
      } else {
        var checked = !Boolean(this.release_certificate['student-' + id])
        this.$set(this.release_certificate, 'student-' + id, checked)
        this.postData()
      }
    },
    disableReleaseCertificate(id) {
      var has_birthday = this.attendeeHasBirthday(id)

      if (!has_birthday) {
        this.$set(this.total_coursecompleted, "student-" + id, false)
      }

      return {
        value: !has_birthday,
        type: "birthday"
      }
    },
    attendeeHasBirthday(id) {
      var has_birthday = false

      let attendee = this.attendees.find((i) => i.id == id)
      if (attendee && attendee.participant.date_of_birth) {
        has_birthday = true
      }

      return has_birthday
    },
    selectAllRow(id, event) {
      console.log("selectAllRow")
      let _data = JSON.parse(JSON.stringify(this.data))
      let _total_coursecompleted = JSON.parse(JSON.stringify(this.total_coursecompleted))
      //let _release_certificate = JSON.parse(JSON.stringify(this.release_certificate));

      this.attendees.forEach((attendee, index) => {
        if (event && id == attendee.id) {
          _data["student-" + attendee.id].total = 100
          _total_coursecompleted["student-" + attendee.id] = event
        }

        // Check all course completed checkbox
        if (id == null) {
          _total_coursecompleted["student-" + attendee.id] = event
        }

        this.moduletemplates.forEach((moduletemplate, index) => {
          if (attendee.id == id || id == null) {
            //_data['student-' + attendee.id].mt['mt-' + moduletemplate.id].value = event
          }

          moduletemplate.moduleoptions.forEach((moduleoption, index) => {
            if (attendee.id == id || id == null) {
              //_data['student-' + attendee.id].mt['mt-' + moduletemplate.id].mo['mo-' + moduleoption.id].value = event
            }
          })
        })
      })

      this.data = _data
      this.total_coursecompleted = _total_coursecompleted
      //this.release_certificate = _release_certificate
      this.postData()
    },
    selectAllColumn(type, id, event) {
      let _data = JSON.parse(JSON.stringify(this.data))

      this.attendees.forEach((attendee, index) => {
        this.moduletemplates.forEach((moduletemplate, index) => {
          if (type == "mt") {
            if (moduletemplate.id == id && !this.disabled_moduletemplates["student-" + attendee.id]["mt-" + moduletemplate.id]) {
              _data["student-" + attendee.id].mt["mt-" + moduletemplate.id].value = event
            }
          }

          if (type == "mo") {
            moduletemplate.moduleoptions.forEach((moduleoption, index) => {
              if (moduleoption.id == id && !this.disabled_moduleoptions["student-" + attendee.id]["mo-" + moduleoption.id]) {
                _data["student-" + attendee.id].mt["mt-" + moduletemplate.id].mo["mo-" + moduleoption.id].value = event
              }
            })
          }
        })
      })

      this.data = _data
      this.postData()
    },
    save(create_certificate = false) {
      // revert back all the release certificate checkbox
      if (!create_certificate) {
        for (const [index, releasecertificate] of Object.entries(this.before_release_certificate)) {
          if (this.release_certificate[index] && this.release_certificate[index] != this.before_release_certificate[index]) {
            this.data[index].release_certificate = false
          }
        }
      }

      // Update old values/arrays
      this.before_total_coursecompleted = JSON.parse(JSON.stringify(this.total_coursecompleted))
      this.before_release_certificate = JSON.parse(JSON.stringify(this.release_certificate))
      this.before_data = JSON.parse(JSON.stringify(this.data))

      axios
        .put(this.API_URL + "course/accomplishment", {
          id: this.course.id,
          data: this.data,
          create_certificate: create_certificate
        })
        .then((res) => {
          if (!this.silent_update) {
            if (this.coursetemplate && this.coursetemplate.type == 2) {
              this.$awn.success(this.$t("attendees.accomplishment_long_course_update_success"))
            } else {
              this.$awn.success(this.$t("global.update_success"))
            }

            this.course = res.data.data
            this.moduletemplates = res.data.data.moduletemplates.filter((i) => !i.hide_in_accomplishment)
            this.ensureModuleTemplateKeys()
            //this.attendeeList();
          } else {
            this.$emit("callback_sua_update")
          }
        })
        .catch((err) => console.log(err))
    },
    preSave() {
      let showPrompt = false

      // Check if there are new course completed checkbox checked
      for (const [index, coursecompleted] of Object.entries(this.before_total_coursecompleted)) {
        //if(this.total_coursecompleted[index] && this.total_coursecompleted[index] != this.before_total_coursecompleted[index]) showPrompt = true;
      }

      for (const [index, releasecertificate] of Object.entries(this.before_release_certificate)) {
        if (this.release_certificate[index] != this.before_release_certificate[index]) showPrompt = true
      }

      for (const [student_id, item] of Object.entries(this.before_data)) {
        /*for (const [moduletemplate_id, moduletemplate] of Object.entries(item.mt)) {
                    if(this.data[student_id].mt[moduletemplate_id].value && this.data[student_id].mt[moduletemplate_id].value != moduletemplate.value) showPrompt = true;
                }*/
      }

      if (showPrompt) {
        this.$awn.confirm(
          this.$t("attendees.expertise_checked_confirm"),
          () => {
            this.save(true)
          },
          () => {
            this.save(false)
          },
          {
            labels: {
              confirmOk: this.$t("global.yes"),
              confirmCancel: this.$t("global.no")
            }
          }
        )
      } else {
        this.save(false)
      }
    },

    showForm(id, type) {
      this.currentFormId = id
      this.currentForm = type + "-form"
    },
    return_modal_form(data) {
      this.return_modal_cancel_form()
      this.attendeeList()
    },
    return_modal_cancel_form() {
      this.currentFormId = null
      this.currentForm = null
      this.showDialogForm = false
    },

    openHistoryDialog(record) {
      this.selectedAttendee = record
      this.showHistoryDialog = true
      this.log_list()
    },

    closeHistoryDialog() {
      this.selectedAttendee = {}
      this.showHistoryDialog = false
      this.logs = []
    },

    openDateDialog(attendeeId) {
      this.selectedDateAttendeeId = attendeeId
      this.showDateDialog = true
    },
    closeDateDialog() {
      this.showDateDialog = false
      this.selectedDateAttendeeId = null
    },
    clearSelectedDate() {
      this.computedSelectedDate = null
      this.closeDateDialog()
    },
    log_list() {
      this.show_loading = true

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, { action_id: this.selectedAttendee.id, action_model: "accomplishment" })

      axios
        .get(this.API_URL + "logs" + "?" + query)
        .then((res) => {
          let data = res.data.data
          data.forEach((item) => {
            let before = item.before_value ? JSON.parse(item.before_value) : []
            let after = item.after_value ? JSON.parse(item.after_value) : []

            for (const key in before) {
              if (key == "mt" || key == "mo") {
                let subitems = before[key]
                for (const subkey in subitems) {
                  let log = subitems[subkey]
                  this.logs.push({
                    date: item.created_at ? this.moment(item.created_at).format(this.DATE_FORMAT + " " + this.TIME_FORMAT) : null,
                    log:
                      (log.value ? this.$t("global.unchecked") : this.$t("global.checked")) +
                      ` ${log.name} by ${item.user.person.first_name} ${item.user.person.last_name}`
                  })
                }
              }

              if (key == "total") {
                let log_before = before[key]
                let log_after = after[key]

                // unchecked
                if (log_after.value == 100 && (log_before.value != 100 || log_before.value == false)) {
                  this.logs.push({
                    date: item.created_at ? this.moment(item.created_at).format(this.DATE_FORMAT + " " + this.TIME_FORMAT) : null,
                    log:
                      this.$t("global.checked") +
                      `  ` +
                      this.$t("attendees.course_completed") +
                      ` by ${item.user.person.first_name} ${item.user.person.last_name}`
                  })
                }

                // checked
                if (log_after.value != 100 && log_before.value == 100) {
                  this.logs.push({
                    date: item.created_at ? this.moment(item.created_at).format(this.DATE_FORMAT + " " + this.TIME_FORMAT) : null,
                    log:
                      this.$t("global.unchecked") +
                      `  ` +
                      this.$t("attendees.course_completed") +
                      ` by ${item.user.person.first_name} ${item.user.person.last_name}`
                  })
                }
              }

              if (key == "release_certificate") {
                let log = before[key]
                this.logs.push({
                  date: item.created_at ? this.moment(item.created_at).format(this.DATE_FORMAT + " " + this.TIME_FORMAT) : null,
                  log:
                    (log.value ? this.$t("global.unchecked") : this.$t("global.checked")) +
                    `  ` +
                    this.$t("attendees.release_certificate") +
                    ` by ${item.user.person.first_name} ${item.user.person.last_name}`
                })
              }
            }
          })
        })
        .catch((err) => console.log(err))
    }
  }
}
</script>

<style>
.acc-chkbox.v-input--selection-controls {
  margin-top: 0 !important;
}
.table-sticky-wrapper {
  position: relative;
}
.table-sticky-wrapper .v-data-table > .v-data-table__wrapper {
  width: var(--width);
  padding-bottom: 15px;
}
.table-sticky-wrapper .v-data-table > .v-data-table__wrapper > table {
  table-layout: fixed !important;
  width: var(--width);
  position: relative;
}
.table-sticky-wrapper .v-data-table > .v-data-table__wrapper > table th,
.table-sticky-wrapper .v-data-table > .v-data-table__wrapper > table td {
  width: 150px;
}
/* First Column */
.table-sticky-wrapper .v-data-table > .v-data-table__wrapper > table thead th:first-child {
  z-index: 5;
  width: 190px !important;
}
.table-sticky-wrapper .v-data-table > .v-data-table__wrapper > table tbody td:first-child {
  z-index: 1;
}
.table-sticky-wrapper .v-data-table > .v-data-table__wrapper > table thead th:first-child,
.table-sticky-wrapper .v-data-table > .v-data-table__wrapper > table tbody td:first-child {
  background: #c9c7c7;
  position: -webkit-sticky; /* for Safari */
  position: sticky;
  top: 0;
  left: 0;
}

/* 3rd to the last column */
.table-sticky-wrapper .v-data-table > .v-data-table__wrapper > table thead th.sticky:nth-last-child(3) {
  z-index: 5;
  width: 110px;
}
.table-sticky-wrapper .v-data-table > .v-data-table__wrapper > table tbody td.sticky:nth-last-child(3) {
  z-index: 1;
}
.table-sticky-wrapper .v-data-table > .v-data-table__wrapper > table thead th.sticky:nth-last-child(3),
.table-sticky-wrapper .v-data-table > .v-data-table__wrapper > table tbody td.sticky:nth-last-child(3) {
  background: #c9c7c7;
  position: -webkit-sticky; /* for Safari */
  position: sticky;
  top: 0;
  right: 220px;
}

/* 2nd to the last column */
.table-sticky-wrapper .v-data-table > .v-data-table__wrapper > table thead th.sticky:nth-last-child(2) {
  z-index: 5;
  width: 110px;
}
.table-sticky-wrapper .v-data-table > .v-data-table__wrapper > table tbody td.sticky:nth-last-child(2) {
  z-index: 1;
}
.table-sticky-wrapper .v-data-table > .v-data-table__wrapper > table thead th.sticky:nth-last-child(2),
.table-sticky-wrapper .v-data-table > .v-data-table__wrapper > table tbody td.sticky:nth-last-child(2) {
  background: #c9c7c7;
  position: -webkit-sticky; /* for Safari */
  position: sticky;
  top: 0;
  right: 110px;
}

/* Last Column */
.table-sticky-wrapper .v-data-table > .v-data-table__wrapper > table thead th.sticky:last-child {
  z-index: 5;
  width: 110px;
  background: #c9c7c7 !important;
}
.table-sticky-wrapper .v-data-table > .v-data-table__wrapper > table tbody td.sticky:last-child {
  z-index: 1;
}
.table-sticky-wrapper .v-data-table > .v-data-table__wrapper > table thead th.sticky:last-child,
.table-sticky-wrapper .v-data-table > .v-data-table__wrapper > table tbody td.sticky:last-child {
  background: #c9c7c7;
  position: -webkit-sticky; /* for Safari */
  position: sticky;
  top: 0;
  right: 0;
}
.absolute-center {
  margin: auto !important;
  position: absolute !important;
  top: 0 !important;
  bottom: 0 !important;
  right: 2px !important;
}
</style>
